import api from "../../_core/api";
import { GetBillingAlertFailuresParams, GetBillingAlertFailuresResp, MonitoringAccess } from "./types";

export const getMonitoringAccess = async (): Promise<MonitoringAccess> => {
  const { data }: { data: boolean } = await api({
    method: "GET",
    url: "/users/my/monitoring",
  });
  return { hasAccess: data };
};

export const getBillingAlertFailures = async (parameters: GetBillingAlertFailuresParams): Promise<GetBillingAlertFailuresResp> => {
  const { data }: { data: GetBillingAlertFailuresResp } = await api({
    method: "GET",
    url: "/billing-alert-sync-failures",
    params: parameters,
  });
  return data;
};
